export const styles = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1300px',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: '40px',
    marginBottom: '35px',
    overflowY: 'auto',
    width: '100%',
    '& h1,h2,h3,h4': {
      color: theme.palette.secondary.main,
      fontSize: '1.4em',
      lineHeight: '1em',
      margin: '15px 0',
      padding: 0,
    },
  },
  container: {
    marginLeft: '50px',
  },
});

export default styles;
